var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815",
    transform: "translate(-11130 22766)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 125,
    cy: 125,
    r: 125,
    transform: "translate(11130 -22766)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(10600.053 -23403.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M561,734.607s-2.533-3.239-2.775-9.861,0-7.8,0-7.8H690.888v14.277s-.361,4.711-4.828,5.005-94.878,0-94.878,0Z",
    transform: "translate(33.078 47.705)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M643.465,756.229H623.3a2.633,2.633,0,1,1,0-5.266h20.164a2.633,2.633,0,0,1,0,5.266Z",
    transform: "translate(112.228 103.261)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M667.961,756.229h-79.1a2.633,2.633,0,1,1,0-5.266h79.1a2.633,2.633,0,1,1,0,5.266Z",
    transform: "translate(55.991 103.261)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M628.57,756.229H554.58a2.633,2.633,0,1,1,0-5.266h73.99a2.633,2.633,0,1,1,0,5.266Z",
    transform: "translate(0 103.261)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M686.865,786.417H565.495c-4.57,0-8.288-4.5-8.288-10.035V697.768c0-5.535,3.718-10.035,8.288-10.035h121.37c4.568,0,8.283,4.5,8.283,10.035v78.614C695.148,781.917,691.433,786.417,686.865,786.417ZM565.495,693c-2.172,0-3.94,2.141-3.94,4.769v78.614c0,2.628,1.768,4.768,3.94,4.768h121.37c2.17,0,3.935-2.141,3.935-4.768V697.768c0-2.628-1.765-4.769-3.935-4.769Z",
    transform: "translate(31.59 0)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M607.059,713.272H567.773v-5.266h39.286Z",
    transform: "translate(44.545 7.108)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M646.273,719.98h-78.5v-5.266h78.5Z",
    transform: "translate(44.545 18.063)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M646.273,719.98h-78.5v-5.266h78.5Z",
    transform: "translate(44.545 36.063)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M569.631,763.106a5.1,5.1,0,0,1-5.1-5.1V728.794H569.8v28.9l44.692-28.9h9.629L572.4,762.287A5.089,5.089,0,0,1,569.631,763.106Z",
    transform: "translate(43.551 67.057)",
    fill: "#2f4265"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMessage);
export default __webpack_public_path__ + "static/media/empty-message.ff7f74650b312316530e2c5842bbc12e.svg";
export { ForwardRef as ReactComponent };